export default "__VITE_ASSET__BBF4W$VK__"